export default "__VITE_ASSET__DcubVAFX__"